import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { GlobalVariable } from "app/global/global";

@Injectable({
  providedIn: "root",
})
export class MercadopagoService {
  private url: string = GlobalVariable.BASE_API_URL + "api/mp/";

  constructor(private http: HttpClient) {}

  enviarLink(idMedico: number): Observable<any> {
    return this.http.post(this.url + "send-link/" + idMedico, {});
  }

  desvincular(idMedico: number): Observable<any> {
    return this.http.post(this.url + "disconnect/" + idMedico, {});
  }

  listarPagosTurno(idTurno: number): Observable<any> {
    return this.http.get(this.url + "turnos/" + idTurno + "/pagos");
  }

  enviarLinkSaldo(idTurno: number): Observable<any> {
    return this.http.post(this.url + "turnos/" + idTurno + "/enviar-link-saldo", {});
  }
}
